<template>
    <div class="attach-menu-grid">
        <button class="attach-item" @click="triggerFileSelect">
            <div class="icon-wrapper file">
                <i class="ri-file-text-line"></i>
            </div>
            <span class="label">Arquivo</span>
            <input 
                type="file" 
                ref="fileInput" 
                class="d-none" 
                @change="handleFileChange"
                multiple
            >
        </button>

        <button 
            v-if="!chatStore.isTeamMode" 
            class="attach-item" 
            @click="$emit('select', 'contact')"
        >
            <div class="icon-wrapper contact">
                <i class="ri-user-3-line"></i>
            </div>
            <span class="label">Contato</span>
        </button>

        <!-- <button class="attach-item" @click="$emit('select', 'poll')">
            <div class="icon-wrapper poll">
                <i class="ri-bar-chart-horizontal-line"></i>
            </div>
            <span class="label">Enquete</span>
        </button> -->
        <button
            v-if="!chatStore.isTeamMode && !internalChatStore.isInternalChatMode"
            class="attach-item"
            @click="$emit('select', 'note')"
        >
            <div class="icon-wrapper note">
                <i class="ri-sticky-note-line"></i>
            </div>
            <span class="label">Anotação</span>
        </button>

        <li v-permission="'conta.visualizar_templates'">
            <button 
                v-if="!chatStore.isTeamMode" 
                class="attach-item" 
                @click="$emit('select', 'template')"
            >
                <div class="icon-wrapper template">
                    <i class="ri-layout-masonry-line"></i>
                </div>
                <span class="label">Template</span>
            </button>
        </li>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useChatStore } from '@/stores/app/chatStore';
import { useInternalChatStore } from '@/stores/app/chatInternoStore';

const chatStore = useChatStore();
const internalChatStore = useInternalChatStore();
const emit = defineEmits(['select', 'file-selected']);
const fileInput = ref(null);

const triggerFileSelect = () => {
    // Simula o clique no input file
    if (fileInput.value) {
        fileInput.value.click();
    }
};

const handleFileChange = (e) => {
    // Se o usuário selecionou algo
    if (e.target.files && e.target.files.length > 0) {
        emit('file-selected', Array.from(e.target.files));
        // Limpa o input para permitir selecionar o mesmo arquivo novamente se quiser
        e.target.value = '';
    }
};
</script>

<style scoped>
.attach-menu-grid {
    display: flex; 
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px;
    width: auto;
    min-width: 100px;
    justify-content: center;
}
.attach-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: transform 0.2s;
    gap: 8px;
    width: 70px; 
}
.attach-item:hover { transform: scale(1.05); }
.icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #fff;
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}
.icon-wrapper.file { background: linear-gradient(135deg, #7f66ff, #5d3fd3); }
.icon-wrapper.contact { background: linear-gradient(135deg, #007bff, #0056b3); }
.icon-wrapper.poll { background: linear-gradient(135deg, #ffc107, #ff9800); }
/* Âmbar do mesmo tom da faixa da anotação na timeline (--bs-warning), para o
   gatilho e o resultado serem a mesma coisa aos olhos. Ícone escuro, não branco:
   branco sobre amarelo não passa contraste — é a mesma escolha do btn-warning. */
.icon-wrapper.note { background: linear-gradient(135deg, #ffcd39, #e0a800); color: #3f2d00; }
.icon-wrapper.template { background: linear-gradient(135deg, #e91e63, #c2185b); }
.label { font-size: 13px; font-weight: 500; color: var(--bs-body-color); }
</style>